// Products that keep the "Vorbestellen" flow; all other Bagger, Gabelstapler
// and Zubehör items use "Anfrage stellen" (redirect to /kontakt).
const PREORDER_BAGGER_SLUGS = new Set(['mini-bagger-qw12', 'mini-bagger-qw15']);
const PREORDER_ACCESSORY_SLUGS = new Set(['hydraulikhammer', 'zahnloser-loeffel-1200mm']);

export const isInquiryOnly = ({ slug, category, isAccessory }) => {
  if (!slug) return false;
  const s = slug.toLowerCase();
  const c = (category || '').toLowerCase();
  if (isAccessory) return !PREORDER_ACCESSORY_SLUGS.has(s);
  if (c.includes('bagger') || s.includes('bagger')) return !PREORDER_BAGGER_SLUGS.has(s);
  return c.includes('gabelstapler') || s.includes('gabelstapler');
};

export const inquiryUrl = (name) => `/kontakt?produkt=${encodeURIComponent(name)}`;
